module.exports = __webpack_public_path__ + "static/media/MU.475af446.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MU.svg
// module id = 2216
// module chunks = 7